export default __webpack_public_path__ + "locales/ja-JP/ChangeUserTypeDialog.json?hash=9e2a8339372ffa6f2f4e5060466754cf";